import React, { Component } from "react";
import * as s from "./Progressbar.module.scss";

export interface ProgressbarProps extends React.HTMLAttributes<HTMLDivElement> {
  percent: number;
}

export class Progressbar extends Component<ProgressbarProps> {
  render() {
    const { percent, className, ...rest } = this.props;
    const formattedValue = percent % 1 === 0 ? percent : percent * 100;

    let progressbarClasses = [s.progressbar];

    if (className) progressbarClasses.push(className);

    return (
      <div className={progressbarClasses.join(" ")} {...rest}>
        <div className={s.active} style={{ width: `${formattedValue}%` }} />
      </div>
    );
  }
}
